const handleFileSelection = (
  files,
  fileUuid,
  isSelected,
  lastSelectedIndex,
  selectFile,
  unselectFile,
  event,
) => {
  const fileIndex = files.findIndex(file => file.uuid === fileUuid);

  if (fileIndex === -1) {
    return lastSelectedIndex;
  }

  if (isSelected) {
    unselectFile(files[fileIndex].uuid);
  } else if (lastSelectedIndex !== null && event.shiftKey) {
    const startIndex = Math.min(lastSelectedIndex, fileIndex);
    const endIndex = Math.max(lastSelectedIndex, fileIndex);

    for (let i = startIndex; i <= endIndex; i += 1) {
      selectFile(files[i]);
    }
  } else {
    selectFile(files[fileIndex]);
  }

  return fileIndex;
};

export default handleFileSelection;
